// eventHeuristics.ts — geteilte, React-freie Titel-Heuristiken für Kalender-
// Events (Geburtstag / Abwesenheit). Zuvor als identische Kopien in
// CalendarStateContext.tsx und OutlookTermine.tsx vorhanden — hier zentralisiert,
// damit Kalender-Modul und Dashboard-Termine-Karte EINE Wahrheit teilen.
//
// SP1 (Dashboard-Termine-Review 2026-07-05): Die Dashboard-Termine-Karte filtert
// ganztägige Geburtstags- und Abwesenheits-Events heraus (nur DIESE Karte —
// A4). Das Abwesenheits-Keyword-Set folgt bewusst dem BACKEND
// (absence-classify.ts, inkl. „frei") — eine gemeinsame Wahrheit FE↔BE
// (F1 → Entscheidung 4). Hinweis: NICHT zu verwechseln mit
// `allDay.ts:istAbwesenheitEvent`, das für die native RBC-All-Day-Zeile des
// Kalender-Moduls das OutlookTermine-Set (inkl. „ooo"/„out of office") plus die
// Sidecar-Art auswertet und dessen Verhalten unverändert bleibt.

/**
 * Geburtstags-Heuristik (TER-D4): ganztägiges Event, dessen Titel auf einen
 * Geburtstag deutet. 1:1 aus CalendarStateContext.tsx:33-36 bzw.
 * OutlookTermine.tsx:142-145 extrahiert (dort identische Kopien) — Verhalten
 * unverändert.
 */
export const istGeburtstagEvent = (subject: string, isAllDay: boolean): boolean => {
    if (!isAllDay) return false;
    return /geburtstag|geb\.?\s|🎂|🎉\s*geb/i.test(subject || "");
};

/**
 * Abwesenheits-Keyword-Set — 1:1 gespiegelt aus dem Backend
 * (absence-classify.ts:17-23, KEYWORD_RULES): homeoffice / krank / urlaub /
 * frei / abwesend. `frei` zählt als freier Tag (Urlaub). Bewusst OHNE
 * „ooo"/„out of office" (Entscheidung 4 = exaktes Backend-Set) — False
 * Negatives sind akzeptiert (keine spekulativen Zusatzregeln).
 */
const ABWESENHEIT_KEYWORDS = /home\s?office|krank|urlaub|\bfrei\b|abwesend/i;

/**
 * Abwesenheits-Heuristik für die Dashboard-Termine-Karte (Entscheidung 4):
 * ein ganztägiges Event mit einem Abwesenheits-Keyword im Titel gilt als
 * Abwesenheit (Urlaub-/Homeoffice-Einladung an Teamkollegen o. Ä.). Nur
 * `isAllDay`-Events können Abwesenheiten sein — ein zeitgebundenes Meeting mit
 * „Urlaub" im Titel (z. B. „Urlaubsplanung") bleibt ein Termin.
 */
export const istAbwesenheitsEvent = (subject: string, isAllDay: boolean): boolean => {
    if (!isAllDay) return false;
    return ABWESENHEIT_KEYWORDS.test(subject || "");
};
